import React from "react";

import ZIcon from "./ZIcon/ZIcon";
import Pagination from "./Pagination/Pagination";
import styled from "styled-components";

const BTag = ({ children }) => {
  return <span>{children}</span>;
};

const DEFAULT_PAGE_SIZE = 10;

const TablePagination = ({
  totalCount,
  currentPageRowCount,
  siblingCount,
  currentPage,
  onPageChange,
  pageSize = DEFAULT_PAGE_SIZE,
  message = null,
}) => {
  return (
    <TablePaginationDiv>
      <TablePaginationShowingDiv>
        Showing <BTag>{(currentPage - 1) * pageSize + 1}</BTag> to{" "}
        <BTag>{(currentPage - 1) * pageSize + currentPageRowCount}</BTag> of{" "}
        <BTag>{totalCount}</BTag> entries
      </TablePaginationShowingDiv>
      {message ? (
        <div>
          {message}
          <ZIcon unicode="E806" />
        </div>
      ) : null}
      <TablePaginationPaginationDiv>
        <div>
          <Pagination
            totalCount={totalCount}
            siblingCount={siblingCount}
            currentPage={currentPage}
            pageSize={pageSize || 1}
            onPageChange={onPageChange}
          />
        </div>
      </TablePaginationPaginationDiv>
    </TablePaginationDiv>
  );
};
export default TablePagination;

const TablePaginationDiv = styled.div`
  min-width: 100%;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 14px;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`;

const TablePaginationShowingDiv = styled.div`
  font-size: 14px !important;
  font-weight: 400;
  color: #9ca3af;
  @media (min-width: 768px) {
    width: fit-content;
  }
`;

const TablePaginationPaginationDiv = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
  @media (min-width: 768px) {
    margin-left: 1rem;
  }
`;
